import _variables from './variables.json';
import _letterDvDb from './letterDv_db.json';
import _letterDvMNQDb from './letterDvMNQ_db.json';

const EXP_ALPHA_NUM_WITH_DIGIT = /^[A-Za-z0-9.]+-[A-Za-z0-9]$/;

export const isAutoNew = (ppu) => {
    return /^[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}$/i.test(ppu);
}

export const isAutoOld = (ppu) => {
    return /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}$/i.test(ppu);
}

export const isMotoOld = (ppu) => {
    return /^[a-z]{2}0[0-9]{3}$|^[a-z]{2}[0-9]{3}$/i.test(ppu);
}

export const isMotoNew = (ppu) => {
    return /^[mnq][b-d,f-h,j-n,p-t,v-z]{2}0[0-9]{2}$|^[yz][b-d,f-h,j-n,p-t,v-z]{2}0[0-9]{2}$|^[b-d,f-h,j-l,p,r-t,v-z]{3}0[0-9]{2}$/i.test(ppu);
}

export const isCarroArrastre = (ppu) => {
    return /^[a-zA-Z]{3}[1-9]{1}[0-9]{2}$/i.test(ppu);
}

export const cleanPpu = value => {
    let patent = value;

    if (value.match(EXP_ALPHA_NUM_WITH_DIGIT)) {
        patent = value.substring(0, value.length - 2);
    }

    return patent.toString().replace(/[.-]|\s/g, '').toUpperCase()
};

export const patentWithoutVerifier = value => {
    value = cleanPpu(value);

    if (value.match(EXP_ALPHA_NUM_WITH_DIGIT)) {
        return value.substring(0, value.length - 2);
    }

    return value;
};

export class Ppu {
    constructor(ppu) {
        this.ppu = cleanPpu(ppu);
        this.format = this.verifyPpuType(this.ppu);
        this.numbers = this.transformInPreNumber(this);
        this.dv = this.calculateDv(this);
        this.formatted = this.formatPpu(this);
    }

    formatPpu() {
        const dotIndex = this.format.type.indexOf('.');
        return `${this.ppu.substring(0, dotIndex)}.${this.ppu.substring(dotIndex)}-${this.dv}`
    }

    verifyPpuType(ppu) {
        if (ppu.length !== _variables.MAX_LENGTH) {
            throw new Error('Largo de patente (ppu) inválido.');
        }

        if (isMotoNew(ppu)) {
            return _variables.motoNewFormat;
        }

        if (isMotoOld(ppu)) {
            return _variables.motoOldFormat;
        }

        if (isAutoNew(ppu)) {
            return _variables.autoNewFormat;
        }

        if (isAutoOld(ppu)) {
            return _variables.autoOldFormat;
        }

        // if (isCarroArrastre(ppu)) {
        //     throw new Error('Patente (ppu) de tipo de vehículo no permitido (Carro de Arrastre).');
        // }

        throw new Error('Formato de patente (ppu) inválido');
    }

    transformInPreNumber(ppu) {
        const type = ppu.format.type;
        if (type === 'LLL.NNN' || type === 'LLLL.NN') {
            const mnq_start = /^[MNQ][B-D,F-H,J-N,P-T,V-Z]{2}0[0-9]{2}$/i.test(ppu.ppu);
            const yz_start = /^[YZ][B-D,F-H,J-N,P-T,V-Z]{2}0[0-9]{2}$/i.test(ppu.ppu);
            const yz_mnq = yz_start && (ppu.ppu.match(/[mnq]/gi) || []).length !== 0;
            const mnq_variant = ppu.format.name === 'motoNewFormat' && (mnq_start || yz_mnq);
            const ppuToArray = Array.from(ppu.ppu);

            ppuToArray.forEach((letter, key) => {
                if (!Number.isInteger(parseInt(letter))) {
                    ppuToArray[key] = parseInt(this.letterDvDb(mnq_variant)[letter.toUpperCase()]);
                    return;
                }

                ppuToArray[key] = parseInt(letter);
            });

            return ppuToArray;
        }

        if (type === 'LL.NNNN') {
            const ppuLetters = ppu.ppu.substring(0, 2);
            const ppuNumbersAll = `${this.lettersToNumbers(ppuLetters)}${ppu.ppu.substring(2, 6)}`;
            return Array.from(ppuNumbersAll);
        }
    }

    lettersToNumbers(ppuLetters) {
        const transformedPpuLetters = this.letterDvDb()[ppuLetters];

        if (typeof transformedPpuLetters === 'string') {
            return transformedPpuLetters;
        }

        throw new Error('Letras de patente (ppu) de Auto Antiguo inválidas');
    }

    letterDvDb(mnqV = false) {
        return mnqV ? {..._letterDvDb, ..._letterDvMNQDb} : _letterDvDb;
    }

    calculateDv(ppu) {
        const format = ppu.format.type;

        if (format === 'LL.NNNN') {
            const S = ppu.numbers[6] * 2 + ppu.numbers[5] * 3 + ppu.numbers[4] * 4 + ppu.numbers[3] * 5 + ppu.numbers[2] * 6 + ppu.numbers[1] * 7 + ppu.numbers[0] * 2;
            const Ri = S % 11;
            const Rf = 11 - Ri;
            if (Rf === 11) return '0';
            if (Rf === 10) return 'K';
            return Rf.toString();
        }

        if (format === 'LLL.NNN' || format === 'LLLL.NN') {
            const SP = ppu.numbers[5] * 2 + ppu.numbers[4] * 3 + ppu.numbers[3] * 4 + ppu.numbers[2] * 5 + ppu.numbers[1] * 6 + ppu.numbers[0] * 7;

            const R = SP % 11;
            if (R === 0) return '0';
            const RV = 11 - R;
            if (RV === 10) return 'K';

            return RV.toString();
        }
    }
}
